import React from 'react';

import { NavigationSkeleton } from '@lumapps/lumx-navigation/components/NavigationSkeleton';
import { ViewMode } from '@lumapps/lumx-navigation/constants';
import { Suspense } from '@lumapps/utils/components/Suspense';

import { SpaceNavigationProps } from '../../types';

/* istanbul ignore next */
const LazySpaceNavigation = React.lazy(async () => {
    const resolved = await import(
        /* webpackChunkName: 'space-navigation' */
        './SpaceNavigation'
    );

    return { default: resolved.SpaceNavigation };
});

const SpaceNavigation = (props: SpaceNavigationProps) => {
    return (
        <Suspense loadingFallback={<NavigationSkeleton viewMode={ViewMode.horizontal} />}>
            <LazySpaceNavigation {...props} />
        </Suspense>
    );
};

export { SpaceNavigation };
